const constants = Object.freeze({
  LOCALSTORAGE_ACCOUNT: 'heklaCpanelAccount',
  LOCALSTORAGE_BEARER_TOKEN: 'heklaCpanelBearerToken',
});

export default constants;
